export default __webpack_public_path__ + "static/media/S-2Sensor_c.9114e81e.png";